import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';

import { TicketContext } from '../../contexts/TicketContext';
import MeterkastService from '../../services/MeterkastService';

export enum METERKAST_QUERY_KEYS {
  UPLOAD_PHOTOS = 'upload-meterkast-photos',
}

const meterkastService = new MeterkastService();

export const useMeterkastUploadMutation = () => {
  const { ticket } = useContext(TicketContext);

  const { mutateAsync, isPending } = useMutation<void, Error, File[]>({
    mutationKey: [METERKAST_QUERY_KEYS.UPLOAD_PHOTOS],
    mutationFn: async (photos: File[]) => {
      if (!ticket || !ticket.customer?.email) {
        throw new Error('Cannot upload meterkast photos without a ticket and customer email');
      }

      const customerEmail = ticket.customer.email;

      await meterkastService.uploadPhotos({
        customerEmail,
        customerId: ticket.customerId,
        hashId: ticket.hashId,
        jwt: ticket.jwt,
        photos,
      });
    },
  });

  return {
    isUploading: isPending,
    uploadMeterkastPhotos: mutateAsync,
  };
};
